// App
import {UserStatusType} from '@shared/modules/User/enums/UserStatus';

export const TEAMS = 'TEAMS' as const;
export type SelectedUserStatusType = UserStatusType | typeof TEAMS;
